import React from 'react';
import { tooltipPropTypes } from './TooltipPropTypes';
import * as styles from './Tooltip.module.scss';
const Tooltip = ({
  trigger,
  children
}) => {
  if (!trigger && !children) {
    return null;
  }
  return /*#__PURE__*/React.cloneElement(trigger, {
    classname: styles.root,
    children: /*#__PURE__*/React.createElement("div", {
      className: styles.rootTooltip
    }, children)
  });
};
export default Tooltip;